import { z } from 'zod';

import { ValidUuidOrNotSetSchema } from '@vestigas/utils';

import { AddressModel } from './zodAddressModel';

/**
 * Zod validation schema for trade addresses.
 */
export const TradeAddressModel = z
  .object({
    id: ValidUuidOrNotSetSchema,
    issuerAssignedId: z.string().optional(),
    lineOne: z.string().optional(),
  })
  .extend(AddressModel.shape);
